<vwui-modal-header showCloseButton="false">
  <div class="w-full flex items-center">
    <h3>Focuspunt bepalen</h3>
    <app-icon-close class="cursor-pointer ml-auto h-3 w-3 text-neutral-1" aria-label="Modal sluiten"
    (click)="modalRef.close()"></app-icon-close>
  </div>
</vwui-modal-header>

@if (focusedPhoto$ | async; as focusedPhoto) {
  <vwui-modal-body class="project-modal-body">
    <p>
      Geef hieronder het focuspunt van de foto aan. Dit is het belangrijkste onderdeel van de foto. Het focuspunt zorgt ervoor dat dit
      onderdeel van de foto op elke resolutie te zien is. Zodra je het focuspunt verplaatst zie je direct het resultaat voor de meest
      voorkomende resoluties.
    </p>
    <div class="mt-4">
      <div class="flex mt-4 h-110">
        <div class="flex-1 flex items-center justify-center bg-gray-100">
          <div class="max-h-full max-w-full">
            <img #focusSelector [src]="imgSrc"
              sizes="50vw" [srcset]="imgSrcset"
              class="max-h-110 object-contain focus-point-modal__focus-selector">
          </div>
        </div>
        <div class="flex flex-col flex-basis-60 mx-4">
          <app-photo [photo]="focusedPhoto" class="w-60 h-60"></app-photo>
          <app-photo [photo]="focusedPhoto" class="w-60 h-45 mt-auto"></app-photo>
        </div>
        <div class="flex-basis-73">
          <app-photo [photo]="focusedPhoto" class="h-full"></app-photo>
        </div>
      </div>
    </div>
  </vwui-modal-body>
  <vwui-modal-footer>
    <vwui-button class="is-light" (click)="modalRef.close()">Annuleren</vwui-button>
    <vwui-button class="is-primary" (click)="saveFocusPoint(focusedPhoto)">Opslaan</vwui-button>
  </vwui-modal-footer>
}
